import React from "react";
import "./terms-condition.css";
import Footer from "../pages/Footer";

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Terms & Conditions</h1>
      
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using PrrepX Pathshala (www.prrepxpathshala.live) and its associated services,
          including online courses, study materials, and platform features (“Services”), you agree to 
          be bound by these Terms and Conditions. If you do not agree, please do not use our Services.
        </p>
      </section>

      <section>
        <h2>2. User Registration and Account</h2>
        <p>
          Users may be required to register to access certain features. During registration, you must provide accurate,
          complete, and updated information. You are responsible for maintaining the confidentiality of your account credentials
          and for all activities under your account.
        </p>
      </section>

      <section>
        <h2>3. Use of Services</h2>
        <p>
          Users agree to use PrrepX Pathshala services only for lawful educational purposes. Unauthorized use, including 
          copying, distributing, or commercial exploitation of content without prior consent, is strictly prohibited.
        </p>
      </section>

      <section>
        <h2>4. Intellectual Property</h2>
        <p>
          All content on the platform, including videos, PDFs, images, quizzes, and text, are the intellectual property
          of PrrepX Pathshala and are protected by copyright and trademark laws. Users may access content for personal
          educational use only and may not modify, distribute, or use it commercially without explicit permission.
        </p>
      </section>

      <section>
        <h2>5. Privacy and Data Protection</h2>
        <p>
          Your use of the platform is governed by our <a href="/privacy">Privacy Policy</a>. PrrepX Pathshala takes 
          reasonable steps to protect your personal information and will not share it with third parties 
          except as outlined in our Privacy Policy.
        </p>
      </section>

      <section>
        <h2>6. Payment and Refunds</h2>
        <p>
          All purchases of courses or materials are final. No refunds are provided except in cases of technical
          errors or damaged products. Mistaken purchases may be exchanged for a different course of equivalent value
          within 10 days of purchase. Delivery issues due to incorrect addresses are the responsibility of the user.
        </p>
      </section>

      <section>
        <h2>7. Third-Party Services</h2>
        <p>
          Our platform may contain links to third-party websites, tools, or services. PrrepX Pathshala is not
          responsible for the availability, content, or privacy practices of these third-party services.
        </p>
      </section>

      <section>
        <h2>8. Security</h2>
        <p>
          We implement reasonable technical, administrative, and physical safeguards to protect your data.
          However, no system is entirely secure, and we cannot guarantee absolute security of your information.
        </p>
      </section>

      <section>
        <h2>9. User Content</h2>
        <p>
          Users may upload comments, questions, or other content on the platform. By uploading content, you grant
          PrrepX Pathshala a worldwide, non-exclusive, royalty-free license to use, display, and distribute such content
          for educational and promotional purposes.
        </p>
      </section>

      <section>
        <h2>10. Limitation of Liability</h2>
        <p>
          PrrepX Pathshala is not liable for any indirect, incidental, or consequential damages arising from the use
          of the platform. Users agree to use the platform at their own risk.
        </p>
      </section>

      <section>
        <h2>11. Modifications to Terms</h2>
        <p>
          PrrepX Pathshala reserves the right to modify or update these Terms at any time. Users are encouraged
          to review this page periodically. Continued use of the platform constitutes acceptance of any changes.
        </p>
      </section>

      <section>
        <h2>12. Governing Law</h2>
        <p>
          These Terms are governed by and construed in accordance with the laws of India. Any disputes arising
          from the use of this platform shall be subject to the exclusive jurisdiction of courts in India.
        </p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>
          If you have any questions regarding these Terms and Conditions, you can reach us:
          <br />📧 Email: prexpathshala@gmail.com
          <br />📍 Website: <a href="https://prrepxpathshala.live">www.prrepxpathshala.live</a>
        </p>
      </section>

      {/* Footer */}
       <Footer />
    </div>
  );
};

export default Terms;
